module.exports = __webpack_public_path__ + "img/ec.612344ff.jpg";